import styled from "styled-components";
import { BONUS_IMG, RefreshOutlined, IMG_Wallet_BG } from "@assets";
import { REJECTED_SK, REQUESTED_SK } from "@constants";

export const RootContainer = styled.div`
  position: relative;
  height: 100vh;
  overflow: hidden;
`;

export const RefreshIcon = styled(RefreshOutlined)`
  font-size: 24px;
  color: #fff;
`;

export const EmptyText = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #808080;
`;

export const ListContainer = styled.div`
  height: calc(100vh - 350px);
  overflow-y: auto;
  border-radius: 15px 15px 0px 0px;

  .loader {
    height: calc(100vh - 406px);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .empty-box {
    height: calc(100vh - 406px);
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: center;
    justify-content: center;

    svg {
      font-size: 24px;
      color: #808080;
    }
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const ListItem = styled.div`
  padding: 16px;
  margin-bottom: 1px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  gap: 12px;
  @media screen and (max-width: 350px) {
    padding: 6px;
    grid: 6px;
  }
  border-top: 1px solid #f2f1f0;
`;

export const DataWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 5px;
`;

export const ItemImage = styled.img.attrs({
  alt: "img",
})`
  width: 55px;
  height: 55px;
  border-radius: 8px;
  object-fit: cover;

  @media screen and (max-width: 350px) {
    width: 38px;
    height: 38px;
  }
`;

export const InfoWrapper = styled.div`
  flex: 1;
  display: flex;
  width: 100%;

  > :nth-child(1) {
    flex: 1;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* grid-gap: 8px; */
`;

export const ItemText = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 200;
  line-height: 1.5;
  text-transform: capitalize;
  color: #13100f;

  @media screen and (max-width: 400px) {
    font-size: 13px;
  }

  @media screen and (max-width: 300px) {
    font-size: 12px;
  }
`;

export const DateText = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 200;
  line-height: 1.5;
  color: #8e969f;

  @media screen and (max-width: 300px) {
    font-size: 11px;
  }
`;

export const AmountText = styled.div`
  white-space: nowrap;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: #13100f;

  @media screen and (max-width: 400px) {
    font-size: 13px;
  }

  @media screen and (max-width: 300px) {
    font-size: 12px;
  }
`;

export const StatusText = styled.div`
  height: 100%;
  white-space: nowrap;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5;
  text-transform: capitalize;
  color: ${(props) =>
    props.status === REQUESTED_SK
      ? "#482701"
      : props.status === REJECTED_SK
      ? "#E81530"
      : "#148E2F"};
  background-color: ${(props) =>
    props.status === REQUESTED_SK
      ? "#FFF5B0"
      : props.status === REJECTED_SK
      ? "#FFE4E4"
      : "#D3FEB2"};
  border-radius: 3px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 300px) {
    font-size: 11px;
  }
`;

export const BonusStatusText = styled(StatusText)`
  text-transform: none;
  width: auto;
  color: ${(props) => (props.status === "Used" ? "#E81530" : "#23AB41")};
  background-color: ${(props) =>
    props.status === "Used" ? "#FFE4E4" : "#D3FEB2"};
`;

export const LogoImage = styled.img.attrs({
  alt: "img",
  src: BONUS_IMG,
})`
  width: 50px;
  border-radius: 12px;
  object-fit: contain;
  align-self: center;
`;

export const Image = styled.img.attrs({
  alt: "img",
})`
  width: 50px;
  border-radius: 12px;
  object-fit: contain;
  align-self: center;
`;

export const ExpiredLabel = styled.span`
  white-space: nowrap;
  color: #e81530;
  font-size: 12px;
  font-style: normal;
  font-weight: 200;
  line-height: 1.5;

  @media screen and (max-width: 365px) {
    font-size: 11px;
  }
`;

export const ExpiredText = styled(ExpiredLabel)`
  color: #8e969f;
`;

export const TitleWrapper = styled.div`
  display: flex;
  margin: 20px 16px 16px 16px;
`;

export const Title = styled.div`
  flex: 1;
  font-size: 16px;
  font-weight: 200;
  color: #f9f9f9;
`;

export const LinkText = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #ffb829;
  cursor: pointer;
`;

export const BalanceWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 16px;
  background: #fff;
  margin: 16px;
  padding: 0px 12px 12px 12px;
`;

export const BalanceTitle = styled.div`
  background-image: url(${IMG_Wallet_BG});
  background-size: contain;
  background-repeat: no-repeat;
  width: 234px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #482701;
  font-weight: 600;
  font-size: 12px;
`;

export const BalanceAmount = styled.div`
  color: #13100f;
  font-size: 24px;
  font-weight: 600;
  margin-top: 8px;
  margin-bottom: 8px;
`;

export const SubBalanceWrapper = styled.div`
  background: #f2f1f0;
  border-radius: 37px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  margin: 0px 16px 16px;
  padding: 5px;
`;

export const SubBalanceTextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SubBalanceText = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: #8e969f;
  padding-left: 3px;
  padding-right: 3px;

  @media screen and (max-width: 345px) {
    font-size: 9px;
  }
`;

export const SubBalanceTitle = styled(SubBalanceText)`
  color: #482701;
`;

export const BalanceButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
`;

export const BalanceButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 160px;
  height: 52px;
  border-radius: 12px;
  background: linear-gradient(269.14deg, #ffe83a 0.75%, #ff961b 99.27%);
  color: #13100f;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  svg {
    padding-left: 5px;
  }

  @media screen and (max-width: 385px) {
    width: 100%;
    font-size: 12px;
  }
`;

export const SellAllWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
  border-radius: 0px !important;

  .ant-btn-primary {
    width: 100%;
    border-radius: 0px !important;
    height: 50px;
  }
`;
